import { UrlUtils } from '@notes/webintegrations-common'
import { Constants } from '../shared/Constants'

const ONENOTE_MEMORY_ENDPOINT = 'www.onenote.com/memory/feed'

export const isEdgeHubQueryParamPresent = (): boolean => {
  const queryParams = UrlUtils.getQueryParamsAsObject(window.location.href)
  return (queryParams && queryParams[Constants.EDGE_HUB_QUERY_FIELD] && queryParams[Constants.EDGE_HUB_QUERY_FIELD].startsWith('true')) || window.location.href.indexOf(ONENOTE_MEMORY_ENDPOINT) !== -1
}

export const isServiceWorkerEnabled = (): boolean => {
  return window.location.href.indexOf(ONENOTE_MEMORY_ENDPOINT) !== -1
}

export const isMsaAccountLogin = (): boolean => {
  const queryParams = UrlUtils.getQueryParamsAsObject(window.location.href)

  if (queryParams && queryParams[Constants.AUTH_QUERY_FIELD]) {
    return queryParams[Constants.AUTH_QUERY_FIELD] === '1'
  }

  return false
}
